import { HistoryEntry, HistoryAction, HistoryContext } from './types';
import { truncate } from './truncate';
import { localActionStorage } from './local-action-storage';

export interface ActionStorage {
  read(): HistoryEntry[];
  write(history: HistoryEntry[]): void;
}

export interface ActionRecorderOptions {
  storage: ActionStorage;
  maxEntriesPerType: number;
}

export class ActionRecorder {
  private storage: ActionStorage;
  private maxEntriesPerType: number;

  constructor({ storage, maxEntriesPerType }: ActionRecorderOptions) {
    this.storage = storage;
    this.maxEntriesPerType = maxEntriesPerType;
  }

  append(action: HistoryAction, context: HistoryContext): void {
    const previous = this.get();

    const entry: HistoryEntry = {
      count: 1,
      timestamp: Date.now(),
      action,
      context,
    };

    const updated = truncate([entry, ...previous], this.maxEntriesPerType);

    this.storage.write(updated);
  }

  get(): HistoryEntry[] {
    return this.storage.read();
  }
}

const MAX_ENTRIES_PER_TYPE = 16;

export const ActionHistory = new ActionRecorder({
  maxEntriesPerType: MAX_ENTRIES_PER_TYPE,
  storage: localActionStorage,
});
